




































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ReturObatForm from "./ReturObatForm.vue";
import ReturObatHasilVerifikasi from "./ReturObatHasilVerifikasi.vue";
import ReturObatVerifikasi from "./ReturObatVerifikasi.vue";
import { storeReturObat } from "@/store/modules/ReturObatStore";
import ReturObatSvc from "@/services/ReturObatService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import moment from "moment";

@Component({
  components: {
    ReturObatForm,
    ReturObatHasilVerifikasi,
    ReturObatVerifikasi,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class ReturObatList extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("retur_obat", "create");
  }

  showForm = false;
  showDetail = false;
  showVerifikasi = false;
  selectedItem: any = null;
  editData: any = null;

  tableHeaders = [
    { text: "No. Retur", value: "nomor_retur", width: "160px" },
    { text: "Tanggal", value: "tanggal_retur", width: "100px" },
    { text: "Alasan", value: "alasan_retur" },
    { text: "Items", value: "total_items", width: "80px", sortable: false },
    { text: "Nilai Retur", value: "total_nilai_retur", width: "120px" },
    { text: "Status", value: "status", width: "130px", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, width: "160px" },
  ];

  alasanMap: Record<string, string> = {
    pasien_pulang: "Pasien Pulang",
    terapi_berubah: "Perubahan Terapi",
    efek_samping: "Efek Samping/Alergi",
    pasien_meninggal: "Pasien Meninggal",
    pasien_pindah: "Pasien Pindah",
    salah_dispensing: "Salah Dispensing",
    expired: "Expired",
    rusak: "Rusak",
    lainnya: "Lainnya",
  };

  mounted() {
    storeReturObat.getByRegister(this.register);
  }

  get storeRetur() {
    return storeReturObat;
  }

  get items() {
    return storeReturObat.items;
  }

  alasanLabel(key: string) {
    return this.alasanMap[key] || key;
  }

  formatDate(date: string) {
    return date ? moment(date).format("DD-MM-YYYY") : "-";
  }

  formatCurrency(val: number) {
    return "Rp " + val.toLocaleString("id-ID");
  }

  tambah() {
    this.editData = null;
    this.showDetail = false;
    this.showVerifikasi = false;
    this.showForm = true;
  }

  edit(item: any) {
    this.editData = item;
    this.showDetail = false;
    this.showVerifikasi = false;
    this.showForm = true;
  }

  lihat(item: any) {
    this.selectedItem = item;
    this.showForm = false;
    this.showVerifikasi = false;
    this.showDetail = true;
  }

  cancelForm() {
    this.showForm = false;
    this.editData = null;
  }

  onSaved() {
    this.showForm = false;
    this.showDetail = false;
    this.editData = null;
    storeReturObat.getByRegister(this.register);
  }

  onVerified() {
    this.showVerifikasi = false;
    this.selectedItem = null;
    storeReturObat.getByRegister(this.register);
  }

  cetakPdf(item: any) {
    ReturObatSvc.printPdf(item.id);
  }

  async hapus(item: any) {
    const q = confirm("Anda yakin akan menghapus retur obat ini?");
    if (q) {
      try {
        const resp = await ReturObatSvc.destroy(item.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          storeReturObat.getByRegister(this.register);
        }
      } catch {
        // handled by service
      }
    }
  }
}
